import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CampaignSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CampaignSVG;
